import { AppSidebar } from './appSidebar';
import { SidebarProvider } from '@/components/ui/sidebar/sidebar';
import { MobileTopBar } from './mobileTopBar';
import { Suspense } from 'react';
import { Loader } from 'lucide-react';

export const SidebarLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <SidebarProvider defaultOpen={false}>
      <AppSidebar />
      <MobileTopBar>
        {/* Pages are lazy-loaded (see router.tsx); keep the sidebar up while
            a page's code downloads. */}
        <Suspense
          fallback={
            <div className="flex h-full w-full items-center justify-center">
              <Loader className="animate-spin" />
            </div>
          }
        >
          {children}
        </Suspense>
      </MobileTopBar>
    </SidebarProvider>
  );
};
